import {
  ModelDocument,
  ModelSignatureItem,
  ModelTransaction,
  OfficeModels,
} from "@/type/core/models/models.types";
import configuration from "@/utils/Config";
import {
  restDeletionHandler,
  restDetailsHandler,
  restPostHandler,
  restUpdateHandler,
  restUpdateMultipartHandler,
} from "@/utils/rest/RestClient";
import { createEffect } from "effector";
import { GetModelTransactionForOfficesRequestDto } from "@state/transactionModels/request/get.model.transaction.for.offices.request.dto";
import { ModelTransactionSearchRequestDto } from "@state/transactionModels/request/model.transaction.search.request.dto";
import { PostModelCreationRequestDto } from "@state/transactionModels/request/post.model.transaction.request.dto";
import { PageModelTransactionResponseDto } from "@state/transactionModels/response/page.model.transaction.response.dto";
import { TransactionModelDuplicateRequestDto } from "@/state/transactionModels/request/transaction.model.duplicate.request.dto";

const baseUrl = configuration.backendBaseUrl + "/ws/fo";
const modelTransactionsSearchUrl = baseUrl + "/models/transactions/search";
const modelTransactionsUrl = baseUrl + "/models/transactions";
const modelTransactionUrl = baseUrl + "/models/transaction";
const uploadFileUrl = "/uploadFile";
const uploadFilesUrl = "/uploadFiles";
const uploadAttachmentsUrl = "/uploadAttachments";
const officesUrl = modelTransactionsUrl + "/offices";
const attachmentsUrl = "/attachments";
const filesUrl = "/files";
const signaturesUrl = "/signatures";
const duplicateUrl = "/duplicate";

export const requestPostModelsTransactionsSearch = createEffect({
  handler: restPostHandler<
    ModelTransactionSearchRequestDto,
    PageModelTransactionResponseDto
  >(modelTransactionsSearchUrl),
});

export const requestCreateModelTransaction = createEffect({
  handler: restPostHandler<PostModelCreationRequestDto, ModelTransaction>(
    modelTransactionsUrl,
  ),
});

export const requestUpdateModelTransaction = createEffect({
  handler: restUpdateHandler<PostModelCreationRequestDto, ModelTransaction>(
    modelTransactionsUrl,
  ),
});

export const requestUploadModelTransactionFile = createEffect({
  handler: restUpdateMultipartHandler<void>(modelTransactionUrl, uploadFileUrl),
});

export const requestUploadModelTransactionFiles = createEffect({
  handler: restUpdateMultipartHandler<void>(
    modelTransactionUrl,
    uploadFilesUrl,
  ),
});

export const requestUploadModelTransactionAttachments = createEffect({
  handler: restUpdateMultipartHandler<void>(
    modelTransactionUrl,
    uploadAttachmentsUrl,
  ),
});

export const requestDeleteModelTransaction = createEffect({
  handler: restDeletionHandler<void>(modelTransactionUrl),
});

export const requestGetModelTransactionForOffices = createEffect({
  handler: restDetailsHandler<
    OfficeModels[],
    GetModelTransactionForOfficesRequestDto
  >(officesUrl),
});

export const requestGetModelTransaction = createEffect({
  handler: restDetailsHandler<ModelTransaction>(modelTransactionsUrl),
});

export const requestGetModelTransactionAttachments = createEffect({
  handler: restDetailsHandler<ModelDocument[]>(
    modelTransactionsUrl,
    attachmentsUrl,
  ),
});

export const requestGetModelTransactionFiles = createEffect({
  handler: restDetailsHandler<ModelDocument[]>(modelTransactionsUrl, filesUrl),
});

export const requestGetModelTransactionSignatures = createEffect({
  handler: restDetailsHandler<ModelSignatureItem[]>(
    modelTransactionsUrl,
    signaturesUrl,
  ),
});

export const requestPostDuplicateModelTransaction = createEffect({
  handler: restPostHandler<TransactionModelDuplicateRequestDto, void>(
    modelTransactionsUrl,
    duplicateUrl,
  ),
});
